export const leadSourceCookieName = 'leadSource';

export const userLocation = 'userLocation';
